var _defs, _g, _rect, _rect2, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _rect3, _rect4, _rect5, _g7, _path4, _rect6, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeavrOnboradingVerification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 477.026,
    height: 391.29,
    viewBox: "0 0 477.026 391.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10778",
    "data-name": "Path 10778",
    d: "M7393.065,859.009c.02.7.055,1.39.1,2.073a46.211,46.211,0,0,0,1.069,7.2c.063.281.134.559.205.834.057.227.115.451.173.671.016.054.028.109.042.16.1.364.207.728.316,1.086.053.182.111.364.165.54.108.361.228.712.353,1.067.06.172.123.348.187.524s.122.332.18.5l.087.22c.037.1.075.208.118.31.067.176.136.355.211.527.138.345.275.684.426,1.022.071.166.145.336.223.5l.229.511c.077.163.154.326.234.485s.159.329.239.5c.016.035.034.07.053.105.037.074.074.144.11.214s.073.147.11.217c.074.144.147.288.225.435q.042.077.079.153c.062.109.12.217.177.326.146.268.293.531.444.8s.3.524.459.786q.466.776.959,1.533c.165.253.334.5.508.754s.342.5.516.741.354.489.533.732v0c.354.483.725.958,1.1,1.425v0c.192.236.383.469.576.7s.389.46.583.69.4.454.6.681c.163.182.33.364.5.543.1.1.188.2.284.3.239.255.484.511.736.764v0c.212.217.43.434.65.652s.439.428.664.639.446.425.674.633c.137.128.277.253.417.38.235.211.474.422.714.629q.5.431,1.008.853a62.7,62.7,0,0,0,7.611,5.4h0a77.928,77.928,0,0,0,12.332,6.009s0,0,0,0c.666.262,1.337.511,2.007.751.137.051.278.1.416.15h.007a96.508,96.508,0,0,0,12.86,3.562c.5.106,1.008.2,1.508.3,0,0,0,0,0,0s.008,0,.008,0c.193.041.375.077.564.112s.382.07.568.1a108.815,108.815,0,0,0,15.634,1.61c3.332.112,6.658.08,9.978-.07q.431-.014.856-.038c.72-.035,1.434-.077,2.149-.125,4.555-.3,9.1-.8,13.634-1.46q1.69-.244,3.382-.521c4.411-.709,8.814-1.556,13.207-2.479q1.318-.273,2.629-.562c.464-.1.932-.2,1.395-.3l2.061-.46c3.639-.818,7.267-1.674,10.891-2.54,1.077-.259,2.149-.515,3.224-.773,6.553-1.575,13.08-3.15,19.571-4.546h0q2.435-.527,4.858-1.013,2.578-.522,5.153-.984,1.339-.244,2.672-.47,1.57-.268,3.143-.5c.757-.112,1.515-.22,2.271-.32q.951-.124,1.9-.24,5.518-.666,11.067-.949c.1,0,.194-.01.293-.013s.225-.013.337-.016c.559-.029,1.121-.051,1.687-.073.013,0,.022,0,.034,0,.464-.016.924-.032,1.384-.042a.017.017,0,0,1,.011,0c.255-.01.515-.016.77-.022.438-.013.879-.022,1.317-.029.514-.01,1.023-.016,1.534-.022.416-.006.832-.006,1.248-.006h.38c.326,0,.658,0,.984.006.145,0,.289,0,.43,0h.186c.291,0,.579.006.871.013.192,0,.395,0,.6.006.229,0,.457.006.688.016.051,0,.095,0,.144,0,.175,0,.354.006.529.013.049,0,.1,0,.15,0s.129,0,.191,0c.169,0,.34.006.512.016.352.01.7.019,1.046.035l.5.019c.433.013.863.032,1.3.054.117,0,.237.006.357.016.157.006.31.013.464.022.279.013.554.026.829.045.14.006.275.016.406.022l.177.01c.032,0,.06,0,.094.006s.069,0,.1.006c.967.054,1.939.118,2.9.192.079.006.162.01.241.016.049,0,.093.01.142.013.024,0,.052,0,.076,0,.087.006.174.013.257.022.025,0,.053,0,.079.006l.481.038c.078.006.154.013.228.016.094.01.18.016.272.023.112.01.227.019.339.032.086.007.169.016.248.022s.176.016.263.022c.127.01.252.019.38.032.057.006.114.009.169.016.157.016.313.029.47.045l.112.01c.038,0,.078.006.115.013.185.016.37.032.557.051.235.022.469.045.7.07.167.016.333.035.5.051.3.029.592.061.889.1l.471.048c.172.016.342.035.515.054l.746.086a.287.287,0,0,1,.032.006c.741.086,1.475.176,2.213.272l.663.086.941.125.419.057c.287.038.573.08.856.121.3.042.6.086.9.131.331.048.662.1.991.147.644.1,1.286.2,1.933.3.42.067.845.137,1.27.211q2.919.489,5.832,1.064c.479.1.966.192,1.444.291.523.105,1.048.211,1.571.323,1.278.271,2.556.543,3.834.824.035.006.069.013.107.022l.148.032a.747.747,0,0,1,.076.016c.648.144,1.3.281,1.951.428q2.137.47,4.271.955h.008q2.073.465,4.144.943c2.743.633,5.475,1.268,8.215,1.91a.345.345,0,0,0,.06.016c.693.163,1.387.323,2.078.489l.524.125,1.3.307c.763.179,1.53.361,2.294.543,0,0,0,0,.006,0q2.585.608,5.175,1.22l.866.2c.086.019.17.041.255.061l1.953.46c.063.016.123.026.185.042l.01,0,.217.048q1.453.345,2.909.681c.267.064.535.125.8.188.044.01.09.019.139.032s.128.029.191.045c.115.026.233.054.354.083l.205.048a.116.116,0,0,1,.032.006c.185.042.369.086.558.128.17.042.343.08.515.118.022.007.044.01.063.016l.337.077c.159.038.318.077.479.112.414.1.826.189,1.246.281.681.16,1.367.316,2.054.473l.272.061c.647.144,1.295.291,1.948.438.633.144,1.265.281,1.895.422q.863.2,1.726.383c.435.093.865.188,1.3.281.555.124,1.111.243,1.668.364.153.032.31.067.459.1.052.013.105.026.155.035q.85.182,1.7.361c.216.048.434.093.647.137.448.093.892.189,1.336.278l1.289.268c.542.115,1.077.22,1.617.329.008,0,.018,0,.022,0q1.147.235,2.3.46l.172.035c5.877,1.156,11.76,2.208,17.64,3.086.531.083,1.059.16,1.585.236,4.79.693,9.581,1.278,14.384,1.719a212.719,212.719,0,0,0,24.137.917c1.7-.038,3.4-.1,5.1-.182q1.655-.082,3.308-.2,2.483-.168,4.973-.415,4.942-.474,9.9-1.265,4.424-.7,8.866-1.674,4.1-.891,8.22-2.029v0q2.624-.719,5.253-1.549,1.627-.508,3.265-1.064c.431-.144.866-.294,1.3-.447.222-.073.444-.15.666-.23a100.655,100.655,0,0,0,11.027-4.649.272.272,0,0,0,.066-.032c.386-.185.764-.377,1.146-.572h0l.018-.01c.036-.016.071-.032.107-.051.437-.224.876-.45,1.309-.68a104.879,104.879,0,0,0,9.212-5.483v0c.409-.272.817-.549,1.222-.828q3.448-2.368,6.7-5c.229-.185.457-.374.682-.562a104.9,104.9,0,0,0,11.74-11.287q1.792-2,3.469-4.1.441-.546.873-1.1c.287-.368.575-.738.854-1.112.208-.271.412-.543.613-.818.129-.166.254-.339.377-.508.032-.045.064-.086.1-.131.077-.109.157-.214.234-.323l.113-.16c.144-.2.285-.4.425-.594.029-.038.057-.077.084-.115.056-.073.105-.15.159-.227.128-.179.253-.355.377-.534.157-.23.317-.457.474-.687q1.748-2.554,3.338-5.217c.193-.323.383-.646.573-.971.261-.454.522-.911.775-1.371q.907-1.62,1.745-3.281c.146-.294.294-.588.437-.885.124-.249.247-.5.364-.751,0,0,0,0,0,0,.049-.1.094-.192.139-.287.172-.368.346-.741.517-1.112.129-.278.253-.559.378-.837q.368-.829.721-1.658c0-.01.01-.022.014-.032q.176-.426.354-.853c.233-.565.46-1.137.685-1.709.11-.288.22-.572.327-.86s.216-.578.319-.866c.145-.39.282-.773.421-1.16.28-.8.553-1.607.807-2.412,0,0,.008-.01,0-.016a93.591,93.591,0,0,0,3.371-14.224c.019-.112.039-.227.052-.345q.283-1.821.485-3.655a89.294,89.294,0,0,0,.548-11.434c-.008-.735-.032-1.467-.059-2.195-.008-.189-.017-.374-.027-.559-.034-.738-.079-1.476-.13-2.214q-.138-1.888-.361-3.757c0-.006,0-.016,0-.022a74.476,74.476,0,0,0-8.523-27.188,65.978,65.978,0,0,0-6.718-9.981,83.579,83.579,0,0,0-7.969-8.4c-2.277-2.112-4.654-4.134-7.078-6.1q-.426-.35-.864-.7c-6.124-4.923-12.532-9.575-18.5-14.674q-2.7-2.31-5.274-4.748c-.111-.109-.227-.214-.339-.323-3.544-3.364-6.94-6.875-10.3-10.415-4.451-4.687-8.841-9.422-13.425-13.923v0q-1.551-1.519-3.134-3a53.214,53.214,0,0,1-9.772-12.587v0a86.75,86.75,0,0,1-7.339-17.447c-.878-2.843-1.643-5.7-2.322-8.524-3.212-13.3-5.163-27.178-9.866-39.91a74.716,74.716,0,0,0-5.761-12.265c-12.5-21.083-38.144-33.546-62.44-30.351-13.189,1.732-25.136,7.46-36.417,14.68-8.74,5.594-17.086,12.086-25.3,18.31-14.1,10.671-29.541,21.552-46.5,27.351-2,.684-4.02,1.3-6.057,1.834a70.667,70.667,0,0,1-24.562,2.15,71.384,71.384,0,0,1-18.038-4.188c-11.366-4.156-21.992-10.719-32.58-17.508-2.181-1.4-4.357-2.808-6.539-4.2-4.074-2.607-8.16-5.185-12.3-7.6-.971-.569-1.951-1.115-2.93-1.648-12.511-6.741-25.671-10.211-37.755-7.652-9.023,1.907-17.446,7.172-24.547,16.949-11.131,15.306-13.646,35.261-13.114,54.184.3,10.808,3.227,21.53,6.705,32.121,2.726,8.287,5.793,16.492,8.217,24.591q.817,2.741,1.574,5.435.318,1.1.607,2.195.6,2.2,1.136,4.377a113.224,113.224,0,0,1,2.9,16.38s0,0,0,.007a66.541,66.541,0,0,1-.173,14.728v0a54.823,54.823,0,0,1-2.882,11.8,58.15,58.15,0,0,1-4.634,9.677c-.073.118-.143.236-.213.358q-1.126,1.859-2.43,3.725c-2.315,3.319-4.58,6.7-6.718,10.166-5.4,8.747-9.962,17.99-12.387,27.849l-.008.038c-.208.85-.4,1.7-.58,2.556-.056.287-.114.578-.169.866q-.195,1.04-.36,2.089c-.048.31-.1.62-.138.933-.093.617-.169,1.24-.239,1.863a.006.006,0,0,1,0,.01c-.032.313-.067.626-.1.942s-.058.629-.083.946c-.055.633-.094,1.265-.121,1.9s-.052,1.275-.063,1.917C7393.038,857.261,7393.039,858.134,7393.065,859.009Z",
    transform: "translate(-7844.679 -12890.772)",
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26989",
    "data-name": "Rectangle 26989",
    width: 389.906,
    height: 278.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26992",
    "data-name": "Rectangle 26992",
    width: 27.259,
    height: 6.686,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26994",
    "data-name": "Rectangle 26994",
    width: 110.415,
    height: 3.37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26996",
    "data-name": "Rectangle 26996",
    width: 102.773,
    height: 5.103,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26998",
    "data-name": "Rectangle 26998",
    width: 51.289,
    height: 5.063,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27000",
    "data-name": "Rectangle 27000",
    width: 46.519,
    height: 5.06,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27004",
    "data-name": "Rectangle 27004",
    width: 194.874,
    height: 196.278,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27135",
    "data-name": "Rectangle 27135",
    width: 456.075,
    height: 326.289,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66361",
    "data-name": "Group 66361",
    transform: "translate(-1013.602 -446)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35313",
    "data-name": "Group 35313",
    transform: "translate(995 446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16177",
    "data-name": "Group 16177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16065",
    "data-name": "Group 16065",
    transform: "translate(309.133 16.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10767",
    "data-name": "Path 10767",
    d: "M8585.41,747l-4.013.011-4.665.01c-15.918-21.491-.488-45.565-.488-45.565a41.743,41.743,0,0,1,10.86,19.908C8589.377,731.557,8587.394,741.009,8585.41,747Z",
    transform: "translate(-8567.987 -701.454)",
    fill: "#fff",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10768",
    "data-name": "Path 10768",
    d: "M8481.545,789.642l-10,.024c1.986-5.988,3.967-15.441,1.693-25.636a49.2,49.2,0,0,1,11.721-12.88C8491.32,767.215,8486.957,780.642,8481.545,789.642Z",
    transform: "translate(-8454.128 -744.123)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10769",
    "data-name": "Path 10769",
    d: "M8469.313,1023.153l-5.493,29.344-29.838.073-4.62-29.321,8.743-.022,4.669-.01,4.008-.012,10-.024Z",
    transform: "translate(-8429.362 -977.662)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16066",
    "data-name": "Group 16066",
    transform: "translate(210.011 71.162)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10770",
    "data-name": "Path 10770",
    d: "M8877.758,1091.831l-.043,19.807a1.249,1.249,0,0,0,1.244,1.252l73.129.157a1.254,1.254,0,0,0,1.254-1.247l.045-21.4a1.253,1.253,0,0,0-1.248-1.252l-64.447-.139Q8882.77,1090.577,8877.758,1091.831Z",
    transform: "translate(-8877.715 -1089.011)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10771",
    "data-name": "Path 10771",
    d: "M8388.432,2942.614a.527.527,0,0,0-.061,0c.021,0,.04,0,.063.006.059.006.12.01.176.013C8388.555,2942.627,8388.493,2942.621,8388.432,2942.614Z",
    transform: "translate(-8033.729 -2609.335)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10772",
    "data-name": "Path 10772",
    d: "M9454.943,2769.052s0,0-.006,0h0Z",
    transform: "translate(-9250.884 -2460.318)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10773",
    "data-name": "Path 10773",
    d: "M9455.533,2769.074h-.01s0,0,0,0h.006Z",
    transform: "translate(-9251.558 -2460.337)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10774",
    "data-name": "Path 10774",
    d: "M9455.592,2769.081c.05,0,.1,0,.148,0,0,0,0,0,0,0C9455.69,2769.078,9455.645,2769.078,9455.592,2769.081Z",
    transform: "translate(-9251.776 -2460.337)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10775",
    "data-name": "Path 10775",
    d: "M7951.784,1880.883c.009.115.021.227.031.342.723,8.275,4.815,16.093,9.739,22.885,13.414,18.514,33,31.424,52.146,43.919q2.657,1.731,5.312,3.464,5.253,3.426,10.518,6.84c.34.217.677.438,1.015.659,8.253,5.338,16.531,10.635,24.879,15.811.809.5,1.617,1,2.426,1.5h0a.016.016,0,0,0,.013.01q1.337-.245,2.67-.47,1.572-.268,3.143-.5c.759-.112,1.517-.221,2.272-.32q.951-.125,1.9-.24,5.517-.666,11.069-.949c.1,0,.193-.01.292-.013s.225-.013.336-.016c.56-.029,1.12-.051,1.688-.073.011,0,.021,0,.032,0,.464-.016.926-.032,1.384-.042a.017.017,0,0,1,.012,0c.256-.01.516-.016.769-.023q.659-.019,1.32-.029c.511-.01,1.023-.016,1.534-.022.414-.007.829-.007,1.246-.007h.38c.326,0,.658,0,.982.007.146,0,.291,0,.433,0h.185c.292,0,.578.007.87.013.194,0,.395,0,.6.006.229,0,.456.006.687.016.052,0,.1,0,.144,0,.176,0,.354.006.532.012.047,0,.1,0,.148,0s.128,0,.192,0c.169,0,.339.007.511.016.352.009.7.019,1.044.035l.5.019c.433.012.863.032,1.3.054.116,0,.236.006.358.015.156.006.309.013.462.022.279.013.556.026.831.045.14.007.276.016.407.022l.174.01a.882.882,0,0,1,.095.007c.036,0,.068,0,.1.006.968.054,1.939.118,2.9.192.08.006.163.009.242.016.05,0,.095.009.142.012.025,0,.052,0,.077,0,.086.006.173.012.256.022.024,0,.054,0,.08.006l.481.039c.075.007.154.013.228.016.092.009.179.016.271.022l.086.01c.084.006.17.012.253.022l.249.022c.086.006.176.016.264.022.127.01.251.019.379.032.058.007.116.01.17.017.156.016.313.028.468.044l.113.01c.037,0,.077.007.116.013.185.016.369.032.555.051.236.022.47.044.706.07l.5.051c.3.029.591.061.889.1l.469.048c.172.016.343.035.516.054l.748.086c.012,0,.021,0,.031.006.741.086,1.476.176,2.214.272l.661.086.943.125.418.058c.287.038.572.08.857.121s.6.086.9.131c.333.048.662.1.991.147.646.1,1.288.2,1.934.3.419.067.844.137,1.271.211q2.921.489,5.831,1.063c.479.1.965.192,1.444.291.522.105,1.047.211,1.571.323,1.277.271,2.556.543,3.833.824.036.006.07.013.109.022l.147.033a.549.549,0,0,1,.075.016c.65.144,1.3.281,1.953.428,1.424.313,2.845.629,4.271.955h.006q2.076.465,4.145.943c2.743.632,5.475,1.268,8.214,1.91a.335.335,0,0,0,.062.016c.692.163,1.387.323,2.077.489l.525.125,1.3.307c.763.178,1.53.361,2.293.543,0,0,0,0,.007,0q2.587.608,5.176,1.22l.864.2c.088.019.172.042.258.06l1.95.46c.064.016.126.026.187.042,0,0,0,0,.01,0,.07.02.143.035.218.051l.979.23.568.135c.033.006.064.012.1.022.424.1.842.192,1.26.291.269.064.536.124.8.188.046.01.092.019.139.032.063.013.128.029.19.045.116.026.235.054.355.083l.2.048a.1.1,0,0,1,.031.006c.185.041.371.086.56.128.171.042.343.08.514.118.023.006.046.01.066.016l.335.077c.158.039.318.076.479.112s.318.077.48.112q1.512.346,3.023.694l3.025.68q3.417.768,6.84,1.492c.617.134,1.233.265,1.848.4.332.067.662.137.993.2.672.144,1.351.284,2.029.422.357.073.714.147,1.071.217.777.157,1.551.313,2.324.463.054.01.11.022.161.032,5.88,1.159,11.762,2.207,17.646,3.089h0c.528.083,1.054.16,1.58.237,4.791.7,9.586,1.281,14.4,1.718h0a211.365,211.365,0,0,0,24.1.92q2.55-.053,5.1-.182h0c.007,0,.011-.009.019-.013.832-.543,1.648-1.128,2.446-1.748a48.731,48.731,0,0,0,5.938-5.489v0c.916-.99,1.8-2.022,2.664-3.083a77.245,77.245,0,0,0,10.2-17.019c1.7-3.786,3.2-7.681,4.57-11.6l0,0c.349-.99.69-1.987,1.022-2.981q.413-1.226.812-2.46c1.46-4.508,2.792-9.077,3.886-13.693a95.223,95.223,0,0,0,2.812-28.038c-.087-1.338-.222-2.77-.411-4.265,0,0,0-.009,0-.013-1.419-11.281-5.869-26.1-15.331-31.859a56.33,56.33,0,0,0-11.913-5.083c-5.149-1.677-10.543-3.134-15.527-5.22a46.881,46.881,0,0,1-4.818-2.316c-2.442-1.367-4.868-2.792-7.25-4.284-.088-.054-.178-.109-.264-.163-.571-.358-1.136-.722-1.7-1.089-3.386-2.189-6.677-4.518-9.816-7.013-.515-.409-1.023-.818-1.528-1.236-.868-.716-1.729-1.444-2.571-2.188q-3.215-.326-6.462-.617c-19.039-1.728-38.855-2.655-59.213-2.7q-2.587-.005-5.164.01c-.891,0-1.786.01-2.681.022C8068.936,1845.289,7999.045,1859.219,7951.784,1880.883Z",
    transform: "translate(-7875.482 -1666.54)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16067",
    "data-name": "Group 16067",
    transform: "translate(404.556 59.225)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10776",
    "data-name": "Path 10776",
    d: "M7901.447,1008.232a10.889,10.889,0,0,1,15.963-.305c2.221,2.347.438,7.347-1.084,9.789a10.382,10.382,0,0,1-10.636,4.767c-4.047-.883-7.25-5-6.715-9.1A10.079,10.079,0,0,1,7901.447,1008.232Z",
    transform: "translate(-7898.917 -1004.595)",
    fill: "#ababf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16068",
    "data-name": "Group 16068",
    transform: "translate(455.035 129.282)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10777",
    "data-name": "Path 10777",
    d: "M7626.608,1501.45a4.3,4.3,0,0,1,6.3-.121c.876.926.172,2.9-.428,3.862a4.1,4.1,0,0,1-4.2,1.88,3.418,3.418,0,0,1-2.647-3.591A3.985,3.985,0,0,1,7626.608,1501.45Z",
    transform: "translate(-7625.611 -1500.016)",
    fill: "#1f60e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16081",
    "data-name": "Group 16081",
    transform: "translate(18.602 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16069",
    "data-name": "Group 16069",
    transform: "translate(0.002)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10778-2",
    "data-name": "Path 10778",
    d: "M7393.065,859.009c.02.7.055,1.39.1,2.073a46.211,46.211,0,0,0,1.069,7.2c.063.281.134.559.205.834.057.227.115.451.173.671.016.054.028.109.042.16.1.364.207.728.316,1.086.053.182.111.364.165.54.108.361.228.712.353,1.067.06.172.123.348.187.524s.122.332.18.5l.087.22c.037.1.075.208.118.31.067.176.136.355.211.527.138.345.275.684.426,1.022.071.166.145.336.223.5l.229.511c.077.163.154.326.234.485s.159.329.239.5c.016.035.034.07.053.105.037.074.074.144.11.214s.073.147.11.217c.074.144.147.288.225.435q.042.077.079.153c.062.109.12.217.177.326.146.268.293.531.444.8s.3.524.459.786q.466.776.959,1.533c.165.253.334.5.508.754s.342.5.516.741.354.489.533.732v0c.354.483.725.958,1.1,1.425v0c.192.236.383.469.576.7s.389.46.583.69.4.454.6.681c.163.182.33.364.5.543.1.1.188.2.284.3.239.255.484.511.736.764v0c.212.217.43.434.65.652s.439.428.664.639.446.425.674.633c.137.128.277.253.417.38.235.211.474.422.714.629q.5.431,1.008.853a62.7,62.7,0,0,0,7.611,5.4h0a77.928,77.928,0,0,0,12.332,6.009s0,0,0,0c.666.262,1.337.511,2.007.751.137.051.278.1.416.15h.007a96.508,96.508,0,0,0,12.86,3.562c.5.106,1.008.2,1.508.3,0,0,0,0,0,0s.008,0,.008,0c.193.041.375.077.564.112s.382.07.568.1a108.815,108.815,0,0,0,15.634,1.61c3.332.112,6.658.08,9.978-.07q.431-.014.856-.038c.72-.035,1.434-.077,2.149-.125,4.555-.3,9.1-.8,13.634-1.46q1.69-.244,3.382-.521c4.411-.709,8.814-1.556,13.207-2.479q1.318-.273,2.629-.562c.464-.1.932-.2,1.395-.3l2.061-.46c3.639-.818,7.267-1.674,10.891-2.54,1.077-.259,2.149-.515,3.224-.773,6.553-1.575,13.08-3.15,19.571-4.546h0q2.435-.527,4.858-1.013,2.578-.522,5.153-.984,1.339-.244,2.672-.47,1.57-.268,3.143-.5c.757-.112,1.515-.22,2.271-.32q.951-.124,1.9-.24,5.518-.666,11.067-.949c.1,0,.194-.01.293-.013s.225-.013.337-.016c.559-.029,1.121-.051,1.687-.073.013,0,.022,0,.034,0,.464-.016.924-.032,1.384-.042a.017.017,0,0,1,.011,0c.255-.01.515-.016.77-.022.438-.013.879-.022,1.317-.029.514-.01,1.023-.016,1.534-.022.416-.006.832-.006,1.248-.006h.38c.326,0,.658,0,.984.006.145,0,.289,0,.43,0h.186c.291,0,.579.006.871.013.192,0,.395,0,.6.006.229,0,.457.006.688.016.051,0,.095,0,.144,0,.175,0,.354.006.529.013.049,0,.1,0,.15,0s.129,0,.191,0c.169,0,.34.006.512.016.352.01.7.019,1.046.035l.5.019c.433.013.863.032,1.3.054.117,0,.237.006.357.016.157.006.31.013.464.022.279.013.554.026.829.045.14.006.275.016.406.022l.177.01c.032,0,.06,0,.094.006s.069,0,.1.006c.967.054,1.939.118,2.9.192.079.006.162.01.241.016.049,0,.093.01.142.013.024,0,.052,0,.076,0,.087.006.174.013.257.022.025,0,.053,0,.079.006l.481.038c.078.006.154.013.228.016.094.01.18.016.272.023.112.01.227.019.339.032.086.007.169.016.248.022s.176.016.263.022c.127.01.252.019.38.032.057.006.114.009.169.016.157.016.313.029.47.045l.112.01c.038,0,.078.006.115.013.185.016.37.032.557.051.235.022.469.045.7.07.167.016.333.035.5.051.3.029.592.061.889.1l.471.048c.172.016.342.035.515.054l.746.086a.287.287,0,0,1,.032.006c.741.086,1.475.176,2.213.272l.663.086.941.125.419.057c.287.038.573.08.856.121.3.042.6.086.9.131.331.048.662.1.991.147.644.1,1.286.2,1.933.3.42.067.845.137,1.27.211q2.919.489,5.832,1.064c.479.1.966.192,1.444.291.523.105,1.048.211,1.571.323,1.278.271,2.556.543,3.834.824.035.006.069.013.107.022l.148.032a.747.747,0,0,1,.076.016c.648.144,1.3.281,1.951.428q2.137.47,4.271.955h.008q2.073.465,4.144.943c2.743.633,5.475,1.268,8.215,1.91a.345.345,0,0,0,.06.016c.693.163,1.387.323,2.078.489l.524.125,1.3.307c.763.179,1.53.361,2.294.543,0,0,0,0,.006,0q2.585.608,5.175,1.22l.866.2c.086.019.17.041.255.061l1.953.46c.063.016.123.026.185.042l.01,0,.217.048q1.453.345,2.909.681c.267.064.535.125.8.188.044.01.09.019.139.032s.128.029.191.045c.115.026.233.054.354.083l.205.048a.116.116,0,0,1,.032.006c.185.042.369.086.558.128.17.042.343.08.515.118.022.007.044.01.063.016l.337.077c.159.038.318.077.479.112.414.1.826.189,1.246.281.681.16,1.367.316,2.054.473l.272.061c.647.144,1.295.291,1.948.438.633.144,1.265.281,1.895.422q.863.2,1.726.383c.435.093.865.188,1.3.281.555.124,1.111.243,1.668.364.153.032.31.067.459.1.052.013.105.026.155.035q.85.182,1.7.361c.216.048.434.093.647.137.448.093.892.189,1.336.278l1.289.268c.542.115,1.077.22,1.617.329.008,0,.018,0,.022,0q1.147.235,2.3.46l.172.035c5.877,1.156,11.76,2.208,17.64,3.086.531.083,1.059.16,1.585.236,4.79.693,9.581,1.278,14.384,1.719a212.719,212.719,0,0,0,24.137.917c1.7-.038,3.4-.1,5.1-.182q1.655-.082,3.308-.2,2.483-.168,4.973-.415,4.942-.474,9.9-1.265,4.424-.7,8.866-1.674,4.1-.891,8.22-2.029v0q2.624-.719,5.253-1.549,1.627-.508,3.265-1.064c.431-.144.866-.294,1.3-.447.222-.073.444-.15.666-.23a100.655,100.655,0,0,0,11.027-4.649.272.272,0,0,0,.066-.032c.386-.185.764-.377,1.146-.572h0l.018-.01c.036-.016.071-.032.107-.051.437-.224.876-.45,1.309-.68a104.879,104.879,0,0,0,9.212-5.483v0c.409-.272.817-.549,1.222-.828q3.448-2.368,6.7-5c.229-.185.457-.374.682-.562a104.9,104.9,0,0,0,11.74-11.287q1.792-2,3.469-4.1.441-.546.873-1.1c.287-.368.575-.738.854-1.112.208-.271.412-.543.613-.818.129-.166.254-.339.377-.508.032-.045.064-.086.1-.131.077-.109.157-.214.234-.323l.113-.16c.144-.2.285-.4.425-.594.029-.038.057-.077.084-.115.056-.073.105-.15.159-.227.128-.179.253-.355.377-.534.157-.23.317-.457.474-.687q1.748-2.554,3.338-5.217c.193-.323.383-.646.573-.971.261-.454.522-.911.775-1.371q.907-1.62,1.745-3.281c.146-.294.294-.588.437-.885.124-.249.247-.5.364-.751,0,0,0,0,0,0,.049-.1.094-.192.139-.287.172-.368.346-.741.517-1.112.129-.278.253-.559.378-.837q.368-.829.721-1.658c0-.01.01-.022.014-.032q.176-.426.354-.853c.233-.565.46-1.137.685-1.709.11-.288.22-.572.327-.86s.216-.578.319-.866c.145-.39.282-.773.421-1.16.28-.8.553-1.607.807-2.412,0,0,.008-.01,0-.016a93.591,93.591,0,0,0,3.371-14.224c.019-.112.039-.227.052-.345q.283-1.821.485-3.655a89.294,89.294,0,0,0,.548-11.434c-.008-.735-.032-1.467-.059-2.195-.008-.189-.017-.374-.027-.559-.034-.738-.079-1.476-.13-2.214q-.138-1.888-.361-3.757c0-.006,0-.016,0-.022a74.476,74.476,0,0,0-8.523-27.188,65.978,65.978,0,0,0-6.718-9.981,83.579,83.579,0,0,0-7.969-8.4c-2.277-2.112-4.654-4.134-7.078-6.1q-.426-.35-.864-.7c-6.124-4.923-12.532-9.575-18.5-14.674q-2.7-2.31-5.274-4.748c-.111-.109-.227-.214-.339-.323-3.544-3.364-6.94-6.875-10.3-10.415-4.451-4.687-8.841-9.422-13.425-13.923v0q-1.551-1.519-3.134-3a53.214,53.214,0,0,1-9.772-12.587v0a86.75,86.75,0,0,1-7.339-17.447c-.878-2.843-1.643-5.7-2.322-8.524-3.212-13.3-5.163-27.178-9.866-39.91a74.716,74.716,0,0,0-5.761-12.265c-12.5-21.083-38.144-33.546-62.44-30.351-13.189,1.732-25.136,7.46-36.417,14.68-8.74,5.594-17.086,12.086-25.3,18.31-14.1,10.671-29.541,21.552-46.5,27.351-2,.684-4.02,1.3-6.057,1.834a70.667,70.667,0,0,1-24.562,2.15,71.384,71.384,0,0,1-18.038-4.188c-11.366-4.156-21.992-10.719-32.58-17.508-2.181-1.4-4.357-2.808-6.539-4.2-4.074-2.607-8.16-5.185-12.3-7.6-.971-.569-1.951-1.115-2.93-1.648-12.511-6.741-25.671-10.211-37.755-7.652-9.023,1.907-17.446,7.172-24.547,16.949-11.131,15.306-13.646,35.261-13.114,54.184.3,10.808,3.227,21.53,6.705,32.121,2.726,8.287,5.793,16.492,8.217,24.591q.817,2.741,1.574,5.435.318,1.1.607,2.195.6,2.2,1.136,4.377a113.224,113.224,0,0,1,2.9,16.38s0,0,0,.007a66.541,66.541,0,0,1-.173,14.728v0a54.823,54.823,0,0,1-2.882,11.8,58.15,58.15,0,0,1-4.634,9.677c-.073.118-.143.236-.213.358q-1.126,1.859-2.43,3.725c-2.315,3.319-4.58,6.7-6.718,10.166-5.4,8.747-9.962,17.99-12.387,27.849l-.008.038c-.208.85-.4,1.7-.58,2.556-.056.287-.114.578-.169.866q-.195,1.04-.36,2.089c-.048.31-.1.62-.138.933-.093.617-.169,1.24-.239,1.863a.006.006,0,0,1,0,.01c-.032.313-.067.626-.1.942s-.058.629-.083.946c-.055.633-.094,1.265-.121,1.9s-.052,1.275-.063,1.917C7393.038,857.261,7393.039,858.134,7393.065,859.009Z",
    transform: "translate(-7393.043 -585.773)",
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10779",
    "data-name": "Path 10779",
    d: "M7393.064,1934.194c.019.706.055,1.406.105,2.1a46.225,46.225,0,0,0,1.069,7.2c.063.281.134.559.205.834.057.227.115.45.173.671.016.054.028.109.042.16.1.364.207.728.316,1.086.053.182.111.364.165.54.112.361.23.712.353,1.067.06.172.123.348.187.524s.122.332.18.5l.087.221c.037.1.075.208.118.31.067.176.136.354.211.527.138.345.275.683.426,1.022.071.166.145.336.223.5s.152.339.229.512.154.325.234.485.159.329.239.5c.016.035.034.07.053.105.037.074.074.144.11.214s.073.147.11.218c.074.144.147.288.225.435q.042.076.079.154c.062.109.12.217.177.326.146.268.293.53.444.8s.3.524.459.786q.466.776.959,1.533c.165.252.334.5.508.754s.342.5.516.741.354.49.533.732v0c.36.482.73.958,1.1,1.425v0c.192.237.383.469.576.7s.389.46.583.691.4.453.6.68c.163.182.33.364.5.543.1.1.19.2.287.3q.36.384.733.763v0c.212.217.43.435.65.652s.439.428.664.639.446.425.674.633c.137.127.277.252.417.38.235.211.474.422.714.63q.5.431,1.008.853a63.226,63.226,0,0,0,7.619,5.389h0a78.194,78.194,0,0,0,12.281,5.984h0q1.03.4,2.071.773c.139.055.276.1.417.151a0,0,0,0,0,0,0,97.784,97.784,0,0,0,12.875,3.56c.51.1,1.023.207,1.534.3,0,0,0,0,0,0,.169.035.341.067.509.1.2.038.411.076.616.108h0a107.879,107.879,0,0,0,15.606,1.607h0c3.32.112,6.638.08,9.954-.07.284-.01.568-.023.849-.038h0c5.272-.265,10.531-.821,15.776-1.585,5.547-.8,11.081-1.837,16.6-3,.873-.185,1.751-.371,2.625-.562q1.73-.375,3.454-.764c3.639-.818,7.271-1.677,10.9-2.543,7.631-1.821,15.225-3.687,22.777-5.31q2.435-.527,4.866-1.013,2.583-.517,5.155-.987h0l1.2-.214c.493-.086.985-.169,1.477-.252q1.576-.268,3.152-.5,2.1-.311,4.188-.562,5.818-.7,11.671-.974h0q1.559-.077,3.116-.118a0,0,0,0,1,.006,0h0c.256-.009.508-.016.765-.022.438-.012.874-.022,1.315-.029h0c.514-.009,1.023-.016,1.534-.019.416-.007.832-.007,1.248-.007h.38c.326,0,.658,0,.984.007.145,0,.289,0,.43,0h.186c.291,0,.579.006.871.012.192,0,.395,0,.6.006.229,0,.457.007.688.017.051,0,.095,0,.144,0,.175,0,.354.006.529.012.049,0,.1,0,.15,0s.129,0,.191,0c.169,0,.34.006.512.016.352.009.7.019,1.046.035l.5.019c.433.013.863.032,1.3.054.117,0,.237.007.357.016.157.007.31.013.464.023.279.013.554.026.829.045.14.006.275.016.406.022l.177.01c.032,0,.06,0,.094.006s.069,0,.1.007c.967.054,1.939.118,2.9.191.079.007.162.01.241.016s.148.01.218.016c.087.006.174.012.257.022.025,0,.053,0,.079.006.24.013.474.035.709.054.094.01.18.016.272.023.112.009.227.019.339.031l.248.022.263.023c.127.009.252.019.38.032l.169.015c.4.035.8.071,1.208.113.017,0,.029,0,.046.006.235.022.469.044.7.07.167.013.333.029.5.051a.631.631,0,0,1,.077.007c.1.013.2.022.3.032.5.052,1,.1,1.5.16l.746.087a.23.23,0,0,1,.032.006c.741.087,1.475.176,2.213.272l.663.086.941.125.419.057c.287.039.573.08.856.122.3.041.6.086.9.131.331.048.662.1.991.147.644.1,1.286.2,1.933.3.42.067.845.137,1.27.211q2.919.488,5.832,1.064c.479.1.966.191,1.444.291.523.105,1.048.21,1.571.323,1.278.271,2.556.543,3.834.824.035.007.069.013.107.022s.1.022.148.032a.687.687,0,0,1,.076.016c.648.144,1.3.281,1.951.428q2.137.469,4.271.955h.008q2.073.465,4.144.943c2.743.632,5.475,1.268,8.215,1.911a.409.409,0,0,0,.06.016c.693.163,1.387.323,2.078.489l.524.124,1.3.307c.763.179,1.53.361,2.294.543,0,0,0,0,.006,0q2.585.609,5.175,1.22l.866.2.255.061,1.953.46c.063.016.123.025.185.041,0,0,.007,0,.01,0,.07.019.145.035.217.052q.494.114.98.23l.569.134c.033.006.065.013.1.022.423.1.84.192,1.26.291.267.064.535.125.8.188.044.01.09.02.139.032s.128.029.191.045c.115.025.233.054.354.083l.205.048a.117.117,0,0,1,.032.007c.185.042.369.086.558.128.17.042.343.08.515.118.022.006.044.01.063.016l.337.077c.159.039.318.077.479.112s.319.077.481.112c1.008.23,2.013.463,3.022.693l3.026.68q3.416.767,6.84,1.492c.616.135,1.233.265,1.847.4.332.067.661.138.993.2q1.012.215,2.028.421c.359.074.717.147,1.073.218.777.156,1.55.313,2.325.463.054.01.107.023.161.032,5.88,1.16,11.761,2.208,17.646,3.089h0c.528.083,1.053.16,1.579.237,4.791.7,9.587,1.281,14.4,1.719h0a211.335,211.335,0,0,0,24.1.921q2.55-.053,5.1-.182h0c1.113-.055,2.221-.118,3.332-.2q2.484-.167,4.968-.412,4.937-.478,9.894-1.268,4.427-.7,8.878-1.674,4.1-.892,8.207-2.029,2.625-.718,5.258-1.55,1.63-.508,3.262-1.063c.433-.144.867-.294,1.3-.448.22-.073.444-.15.664-.23a101.233,101.233,0,0,0,11.032-4.645.521.521,0,0,0,.066-.032c.394-.191.781-.386,1.169-.584l.1-.048q.669-.341,1.335-.7h0a104.971,104.971,0,0,0,9.188-5.469c.408-.271.813-.55,1.22-.827q3.456-2.372,6.715-5.016c.23-.182.456-.368.685-.56a104.278,104.278,0,0,0,11.737-11.29c.271-.3.537-.6.8-.907q1.37-1.568,2.657-3.2.441-.546.873-1.1c.287-.367.575-.738.854-1.111.208-.272.412-.543.613-.818.129-.167.254-.339.377-.508.032-.045.064-.086.1-.131.077-.108.157-.214.234-.323l.113-.16c.144-.2.285-.4.425-.594.029-.038.057-.076.084-.115.056-.073.105-.15.159-.227.128-.179.253-.354.377-.534.163-.227.327-.453.483-.683q1.742-2.544,3.326-5.2c.2-.332.4-.664.588-1,.265-.45.524-.908.775-1.368q.905-1.62,1.732-3.278c.146-.294.294-.588.437-.885.124-.249.247-.5.364-.751,0,0,0,0,0,0,.049-.1.094-.192.139-.288.172-.367.346-.741.517-1.112.129-.278.253-.559.378-.837q.368-.829.721-1.658c0-.01.01-.022.014-.032q.176-.426.354-.853c.233-.565.46-1.137.685-1.709.11-.287.22-.572.327-.859s.216-.578.319-.866c.145-.39.282-.773.421-1.159.28-.8.553-1.607.807-2.412,0,0,.008-.01,0-.016a93.581,93.581,0,0,0,3.371-14.223c.019-.112.039-.227.052-.345q.283-1.822.485-3.655a89.3,89.3,0,0,0,.548-11.435c-.008-.734-.032-1.466-.059-2.195-.008-.188-.017-.374-.027-.559-.034-.738-.079-1.476-.13-2.214q-.138-1.889-.361-3.758a243.061,243.061,0,0,0-29.779-13.8q-12.68-4.935-27-9.178h0c-.025-.009-.053-.016-.077-.025s-.059-.016-.086-.025c-.424-.125-.85-.252-1.279-.377-.057-.016-.118-.032-.174-.051q-13.731-4-28.79-7.31-2.112-.464-4.256-.914a.1.1,0,0,0-.014,0q-3.032-.638-6.1-1.24-8.142-1.606-16.6-2.994-1.979-.325-3.975-.636c-.38-.061-.758-.121-1.138-.178-.072-.01-.149-.022-.223-.035l-.171-.025q-11.471-1.768-23.446-3.118a.036.036,0,0,1-.019,0c-.124-.013-.249-.028-.377-.041h0q-3.97-.445-7.993-.847-2.339-.23-4.7-.444c-19.476-1.782-39.779-2.725-60.647-2.725q-2.5,0-4.99.019c-.886,0-1.776.009-2.665.022-77.959.853-147.475,14.833-194.48,36.466-.036.016-.075.032-.109.048q-6.65,3.062-12.692,6.329-3.151,1.7-6.121,3.457c-16.9,9.968-29.464,21.149-36.649,33.134l-.008.016c-.208.856-.4,1.716-.58,2.578-.056.288-.114.578-.169.866q-.195,1.039-.36,2.089c-.048.31-.1.62-.138.933-.093.617-.169,1.24-.239,1.863,0,0,0,.007,0,.01-.032.313-.067.626-.1.942s-.058.63-.083.946c-.055.633-.094,1.265-.121,1.9s-.056,1.275-.063,1.917Q7393.028,1932.889,7393.064,1934.194Z",
    transform: "translate(-7393.043 -1660.98)",
    fill: "#e3e0ff",
    opacity: 0.872
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16077",
    "data-name": "Group 16077",
    transform: "translate(11.865 21.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16073",
    "data-name": "Group 16073",
    transform: "translate(0 16.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16070",
    "data-name": "Group 16070",
    transform: "translate(34.982 15.419)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10780",
    "data-name": "Path 10780",
    d: "M10138.563,969.825l-.268-8.2a.263.263,0,0,0-.271-.255l-47.826,1.552a.262.262,0,0,0-.253.272l.265,8.2a.264.264,0,0,0,.271.255l47.826-1.552A.266.266,0,0,0,10138.563,969.825Z",
    transform: "translate(-10089.747 -961.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17866",
    "data-name": "Rectangle 17866",
    width: 20.552,
    height: 41.467,
    rx: 2.958,
    transform: "translate(42.268 8.566) rotate(88.141)",
    fill: "#fff",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17867",
    "data-name": "Rectangle 17867",
    width: 17.642,
    height: 55.835,
    rx: 2.958,
    transform: "translate(55.805 27.597) rotate(88.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10781",
    "data-name": "Path 10781",
    d: "M10181.8,1060.936c.594-3.33-.15-7.2-.381-10.565a.484.484,0,0,0-.967.031c-.012,3.373-.5,7.283.309,10.568A.533.533,0,0,0,10181.8,1060.936Z",
    transform: "translate(-10145.984 -1037.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10782",
    "data-name": "Path 10782",
    d: "M10216.078,1062.049c.594-3.329-.152-7.2-.381-10.565a.483.483,0,0,0-.965.031c-.012,3.373-.5,7.283.3,10.568A.535.535,0,0,0,10216.078,1062.049Z",
    transform: "translate(-10185.11 -1038.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10783",
    "data-name": "Path 10783",
    d: "M10250.357,1063.161c.594-3.329-.152-7.2-.381-10.565a.483.483,0,0,0-.965.031c-.012,3.372-.506,7.283.3,10.567A.535.535,0,0,0,10250.357,1063.161Z",
    transform: "translate(-10224.236 -1039.309)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10784",
    "data-name": "Path 10784",
    d: "M8375.088,951.062l-1.045-32.223-24.434.792-.145-4.412,24.435-.793-1.731-53.4-.02-.623c.486-.585.966-1.179,1.434-1.776.095-.118.187-.236.279-.358q2.219-2.871,4.136-5.936l.1,3.185,60.309-1.958c2.186,1.4,4.361,2.805,6.543,4.2l-66.7,2.163,1.759,54.3,4.99-.163h.028l30.294-.984,25.454-.827h.027l61.336-1.99,19.043-.616-1.05-32.335c2.036-.533,4.057-1.15,6.059-1.834l1.1,33.971,18.634-.6,1.67-.054,21.125-.681,6.709-.214,10.376-.339,44.079-1.425,19.091-.616,3.981-.128,10.5-.339,4.942-.16h0l1.547-.048,9.3-.3.14,4.412-12.775.412-.593.019-4.362.141-10.229.329-.987.032-10.979.355h0l-5.337.172h0l-.67.022-.541.016h0l-2.549.083-52.553,1.7-5.959.192-40.289,1.3-.484.016-3.638.118.043,1.252,2.315,71.373-6.105.2-.5-15.271-50.457,1.636-74.631,2.422-16.078.524.222,58.619.1,25.255v.007l.114,30.322,0,.761.053,1.7-6.11.2-.035-1.121-.074-2.3-.1-30.443-.07-20.926-.212-61.877-9.906.319q-.539-2.176-1.135-4.377l10.9-.354-.459-14.246Zm18.1,20.15,2.528-.083,10.777-.348h0l2.878-.1h0l11.941-.383.1,0,7.03-.233h0l7.336-.233,29.907-.971,57.348-1.866-1.618-49.83-.1-3.106-109.2,3.543-31.974,1.035,1.717,52.945Z",
    transform: "translate(-8349.465 -852.335)",
    fill: "#fff",
    opacity: 0.244
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10785",
    "data-name": "Path 10785",
    d: "M10093.664,1449.952l-5.568,2.534a.327.327,0,0,1-.434-.163l-17.766-39.03a.332.332,0,0,1,.162-.435l5.57-2.533a.33.33,0,0,1,.436.163l17.76,39.031A.329.329,0,0,1,10093.664,1449.952Z",
    transform: "translate(-10007.216 -1331.394)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16071",
    "data-name": "Group 16071",
    transform: "translate(34.826 71.483)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10786",
    "data-name": "Path 10786",
    d: "M10299.83,1406.29l-12.234,2.44a.329.329,0,0,1-.387-.258l-9.533-47.794a.325.325,0,0,1,.256-.386l12.234-2.44a.327.327,0,0,1,.385.258l9.535,47.794A.328.328,0,0,1,10299.83,1406.29Z",
    transform: "translate(-10277.668 -1357.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10787",
    "data-name": "Path 10787",
    d: "M10362.924,1395.7c-2.211-.293-4.541.639-6.664,1.066-.506.1-.65.679-.545,1.208s.463,1.009.965.907c2.125-.42,4.635-.454,6.564-1.573A.973.973,0,0,0,10362.924,1395.7Z",
    transform: "translate(-10352.156 -1390.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M10337.562,1522.812c-2.211-.293-4.544.639-6.666,1.066-.5.1-.648.679-.542,1.208s.461,1.008.967.907c2.121-.42,4.634-.455,6.56-1.572A.973.973,0,0,0,10337.562,1522.812Z",
    transform: "translate(-10323.206 -1499.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    "data-name": "Path 10789",
    d: "M10360.367,1453.982a1.987,1.987,0,0,0-1.156,2.464c.234,1.17,1.15,2,2.012,1.831a1.99,1.99,0,0,0,1.156-2.464C10362.143,1454.643,10361.229,1453.81,10360.367,1453.982Z",
    transform: "translate(-10351.532 -1440.368)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16072",
    "data-name": "Group 16072",
    transform: "translate(50.192 78.942)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M10195.069,1450.062l-10.694,2.874a.331.331,0,0,1-.4-.231l-10.435-38.828a.331.331,0,0,1,.232-.4l10.7-2.875a.326.326,0,0,1,.4.232l10.436,38.828A.328.328,0,0,1,10195.069,1450.062Z",
    transform: "translate(-10173.525 -1410.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    "data-name": "Path 10791",
    d: "M10260.6,1458.216c-.768.206-1.058,1.683-.636,3.247s1.411,2.7,2.179,2.491,1.056-1.683.634-3.247S10261.369,1458.01,10260.6,1458.216Z",
    transform: "translate(-10253.385 -1451.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    "data-name": "Path 10792",
    d: "M10237.279,1537.9c-1.034.187-2.042.484-3.058.74a5.887,5.887,0,0,0-2.659.981c-.383.331-.012,1.716.488,1.811a5.894,5.894,0,0,0,2.792-.484c1.007-.287,2.027-.536,3.017-.892.36-.057.379-.66.219-1.215C10237.938,1538.277,10237.62,1537.765,10237.279,1537.9Z",
    transform: "translate(-10224.572 -1519.876)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16076",
    "data-name": "Group 16076",
    transform: "translate(33.435)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    "data-name": "Path 10793",
    d: "M10161.285,742.839A28.6,28.6,0,0,0,10201.56,744c-12.511-6.742-25.669-10.213-37.753-7.654q-.262.753-.526,1.5-.419,1.183-.881,2.346C10162.049,741.081,10161.674,741.962,10161.285,742.839Z",
    transform: "translate(-10161.285 -735.505)",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16074",
    "data-name": "Group 16074",
    transform: "translate(20.799 9.511)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17868",
    "data-name": "Rectangle 17868",
    width: 5.128,
    height: 1.243,
    transform: "matrix(-0.032, -0.999, 0.999, -0.032, 0.165, 5.165)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16075",
    "data-name": "Group 16075",
    transform: "translate(2.384 3.424)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    "data-name": "Path 10794",
    d: "M10398.041,763.46l.9.851,3.507-3.741-.907-.849Z",
    transform: "translate(-10398.041 -759.721)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16080",
    "data-name": "Group 16080",
    transform: "translate(8.974 51.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    "data-name": "Path 10795",
    d: "M10619.468,1844.1c-2.736,2.673-2.464,7.826.654,10.042s8.234.6,9.338-3.065-2.524-7.911-6.286-7.227a10.882,10.882,0,0,0-3.62,1.641Z",
    transform: "translate(-10617.586 -1716.891)",
    fill: "#dbd9f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16078",
    "data-name": "Group 16078",
    transform: "translate(39.191 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_820",
    "data-name": "Ellipse 820",
    cx: 4.385,
    cy: 4.385,
    rx: 4.385,
    ry: 4.385,
    transform: "translate(17.779 9.082) rotate(-92.077)",
    fill: "#fff",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    "data-name": "Path 10797",
    d: "M10411.426,1032.208a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,10411.426,1032.208Z",
    transform: "translate(-10410.33 -1020.082)",
    fill: "#fff",
    opacity: 0.79
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16079",
    "data-name": "Group 16079",
    transform: "translate(221.01 13.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_821",
    "data-name": "Ellipse 821",
    cx: 3.351,
    cy: 3.351,
    r: 3.351,
    transform: "matrix(-0.675, -0.738, 0.738, -0.675, 4.522, 9.47)",
    fill: "#fff",
    opacity: 0.65
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16097",
    "data-name": "Group 16097",
    transform: "translate(150.941 28.781)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10807",
    "data-name": "Path 10807",
    d: "M9342.051,815.445c-13.187-.317-27-6.494-33.158-18.007-.8-1.5-1.475-3.275-.855-4.856a4.947,4.947,0,0,1,2.879-2.552c4.795-1.948,10.283.307,14.463,3.361s7.826,6.973,12.588,9c6.7,2.842,14.4,1.449,21.348-.7,7.145-2.21,15.42-8.127,22.406-2.713-.937,4.392-4.418,5.267-8.129,6.818-6.584,2.751-13.578,6.682-20.479,8.449A40.828,40.828,0,0,1,9342.051,815.445Z",
    transform: "translate(-9307.795 -789.304)",
    fill: "#f1f0fc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_31",
    "data-name": "Mask Group 31",
    transform: "translate(1465.238 12751)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66355",
    "data-name": "Group 66355",
    transform: "translate(687.162 62.549)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27118",
    "data-name": "Rectangle 27118",
    width: 302.562,
    height: 210.644,
    transform: "translate(-1062.443 -12231.673)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27120",
    "data-name": "Rectangle 27120",
    width: 302.562,
    height: 25.225,
    transform: "translate(-1062.521 -12238.682)",
    fill: "#7181bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66343",
    "data-name": "Group 66343",
    transform: "translate(-1095.24 -12282.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66329",
    "data-name": "Group 66329",
    clipPath: "url(#clip-path-2)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66313",
    "data-name": "Group 66313",
    transform: "translate(39.132 52.625)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66312",
    "data-name": "Group 66312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66311",
    "data-name": "Group 66311",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67002",
    "data-name": "Path 67002",
    d: "M257.564,340.843a3.335,3.335,0,1,1-3.338-3.333,3.335,3.335,0,0,1,3.338,3.333",
    transform: "translate(-250.893 -337.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67003",
    "data-name": "Path 67003",
    d: "M323.563,340.792a3.335,3.335,0,1,1-3.338-3.333,3.335,3.335,0,0,1,3.338,3.333",
    transform: "translate(-306.598 -337.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67004",
    "data-name": "Path 67004",
    d: "M389.564,340.741a3.335,3.335,0,1,1-3.338-3.333,3.336,3.336,0,0,1,3.338,3.333",
    transform: "translate(-362.305 -337.408)",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66316",
    "data-name": "Group 66316",
    transform: "translate(131.613 53.842)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66315",
    "data-name": "Group 66315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66314",
    "data-name": "Group 66314",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    y1: 0.083,
    x2: 107.128,
    transform: "translate(1.644 1.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26993",
    "data-name": "Rectangle 26993",
    width: 110.414,
    height: 3.285,
    transform: "translate(0.001 0.043)",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66319",
    "data-name": "Group 66319",
    transform: "translate(212.407 87.246)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66318",
    "data-name": "Group 66318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66317",
    "data-name": "Group 66317",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    y1: 0.076,
    x2: 97.744,
    transform: "translate(2.514 2.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26995",
    "data-name": "Rectangle 26995",
    width: 102.768,
    height: 5.024,
    transform: "translate(0.002 0.039)",
    fill: "#c1a8db"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66322",
    "data-name": "Group 66322",
    transform: "translate(263.892 99.478)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66321",
    "data-name": "Group 66321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66320",
    "data-name": "Group 66320",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    y1: 0.036,
    x2: 46.262,
    transform: "translate(2.514 2.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26997",
    "data-name": "Rectangle 26997",
    width: 51.285,
    height: 5.024,
    transform: "translate(0.002 0.019)",
    fill: "#c1a8db"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66325",
    "data-name": "Group 66325",
    transform: "translate(49.334 87.416)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66324",
    "data-name": "Group 66324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66323",
    "data-name": "Group 66323",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    y1: 0.032,
    x2: 41.491,
    transform: "translate(2.514 2.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26999",
    "data-name": "Rectangle 26999",
    width: 46.515,
    height: 5.024,
    transform: "translate(0.002 0.018)",
    fill: "#c1a8db"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67005",
    "data-name": "Path 67005",
    d: "M389.911,891.874l-66.936.052a5.645,5.645,0,0,1-5.649-5.641l-.085-109.3a5.645,5.645,0,0,1,5.641-5.649l66.936-.052a5.645,5.645,0,0,1,5.65,5.641l.085,109.3a5.645,5.645,0,0,1-5.641,5.65",
    transform: "translate(-267.761 -650.985)",
    fill: "#554bbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67006",
    "data-name": "Path 67006",
    d: "M989.2,891.41l-66.936.052a5.645,5.645,0,0,1-5.65-5.641l-.085-109.3a5.646,5.646,0,0,1,5.641-5.65l66.936-.052a5.645,5.645,0,0,1,5.649,5.641l.085,109.3a5.645,5.645,0,0,1-5.641,5.649",
    transform: "translate(-773.582 -650.594)",
    fill: "#e7e1ed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67007",
    "data-name": "Path 67007",
    d: "M1588.5,902.256l-66.936.056a5.926,5.926,0,0,1-5.649-6.17l-.085-119.554a5.929,5.929,0,0,1,5.641-6.179l66.936-.057a5.927,5.927,0,0,1,5.65,6.17l.085,119.554a5.929,5.929,0,0,1-5.641,6.18",
    transform: "translate(-1279.404 -650.202)",
    fill: "#554bbf"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27001",
    "data-name": "Rectangle 27001",
    width: 15.425,
    height: 3.919,
    transform: "matrix(0.985, -0.172, 0.172, 0.985, 2.287, 48.296)",
    fill: "#554bbf"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27002",
    "data-name": "Rectangle 27002",
    width: 3.919,
    height: 22.93,
    transform: "translate(0 26.487) rotate(-54.925)",
    fill: "#554bbf"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27003",
    "data-name": "Rectangle 27003",
    width: 3.919,
    height: 15.425,
    transform: "matrix(0.987, -0.162, 0.162, 0.987, 24.491, 17.316)",
    fill: "#554bbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66328",
    "data-name": "Group 66328",
    transform: "translate(99.848 44.993)",
    opacity: 0.11,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66327",
    "data-name": "Group 66327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66326",
    "data-name": "Group 66326",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67008",
    "data-name": "Path 67008",
    d: "M834.735,484.757l-194.556-.017.318-196.1,194.556-.16Z",
    transform: "translate(-640.18 -288.479)",
    fill: "#363636"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67104",
    "data-name": "Path 67104",
    d: "M0,0H247.377V196.075H0Z",
    transform: "translate(84.899 247.536) rotate(-90)",
    fill: "#fff"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27119",
    "data-name": "Rectangle 27119",
    width: 389.907,
    height: 278.951,
    transform: "translate(-1095.24 -12282.211)",
    fill: "none"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66360",
    "data-name": "Group 66360",
    transform: "translate(-33.082 -20.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66359",
    "data-name": "Group 66359",
    transform: "translate(1057.16 531.339)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67103",
    "data-name": "Path 67103",
    d: "M0,0H148.358V49.662H0Z",
    transform: "translate(140.785 166.445)",
    fill: "#f1f0fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27122",
    "data-name": "Rectangle 27122",
    width: 148.109,
    height: 5.685,
    transform: "translate(140.91 216.352)",
    fill: "#d4d4d4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeavrOnboradingVerification);
export default __webpack_public_path__ + "static/media/weavr_onborading_verification.65ac8149e207bdded3e34c775f4b8b69.svg";
export { ForwardRef as ReactComponent };